export default __webpack_public_path__ + "static/media/5g.5ba02ca9.png";